import React, { useState, useEffect } from "react";
import ErrorBoundary from "../../components/common/ErrorBoundary/ErrorBoundary";
import { ThreeDots } from "react-loader-spinner";
import { BlockUI } from "primereact/blockui";
import "./css/Login.css";
import SffLanguage from "../../components/common/Languages/SffLanguage";
import LoginService from "../../api/services/login.service";
import { useDispatch, useSelector } from "react-redux";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { RootState } from "../../states/store";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Dropdown } from "primereact/dropdown";
import dropdownIcon from "../../assets/images/arrow_drop_down.svg";
import { useCookies } from "react-cookie";
import {
  getLanguageDetails,
  setLanguage,
  getTokenDetails,
} from "../../states/slice/loginSlice";
import Header from "../Header/Header";

const Login: React.FC = () => {
  const { t, changeLanguage } = SffLanguage();
  const reduxData = useSelector(
    (state: RootState) => state.rootReducer.LoginReducer
  );
  const { languageDetails, language, tokenDetails } = useSelector(
    (state: RootState) => state.login
  );
  const { isApiLoading } = useSelector((state: RootState) => state.general);

  const navigate = useNavigate();
  const action = useDispatch();
  const [loader, setLoader] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState<any>(null);
  const [favoriteLanguage, setFavoriteLanguage] = useState<string>("");

  const [windowDimensions, setWindowDimensions] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [params] = useSearchParams();
  const [cookies, setCookie] = useCookies([
    "codeVerifier",
    "refreshToken",
    "accessToken",
    "userId",
    "expiry",
    "tokenType",
    "userName",
  ]);
  const cookieOptions = {
    httpOnly: false,
    secure: false,
    sameSite: false,
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const accessToken = cookies.accessToken;
    if (accessToken && accessToken !== "undefined") {
      action(getLanguageDetails());
      //navigate("/", { replace: true });
    } else {
      if (params.get("error")) {
        navigate("/accessDenied", { replace: true });
      } else {
        if (params.get("code")) {
          loginHandler();
        } else {
          setLoader(true);
          LoginService.getRedirectURL()
            .then((res) => {
              setCookie("codeVerifier", res.data.codeVerifier, cookieOptions);
              const safeURL = sanitizeURL(res.data.reDirectURL);
              window.location.href = safeURL;
            })
            .catch((error) => { })
            .finally(() => {
              setLoader(false);
            });
        }
      }
    }
  }, []);
  const sanitizeURL = (url: string) => {
    const a = document.createElement("a");
    a.href = url;
    return a.href;
  };
  useEffect(() => {
    changeLanguage(reduxData.language);
  }, [reduxData.language]);

  useEffect(() => {
    console.log(tokenDetails);
    if (Object.keys(tokenDetails).length > 0) {
      setCookie("accessToken", tokenDetails.accessToken, cookieOptions);
      setCookie("refreshToken", tokenDetails.refreshToken, cookieOptions);
      setCookie("userId", tokenDetails.userId, cookieOptions);
      setCookie("expiry", tokenDetails.expiry, cookieOptions);
      setCookie("tokenType", tokenDetails.tokenType, cookieOptions);
      setCookie(
        "userName",
        tokenDetails.firstName + " " + tokenDetails.lastName,
        cookieOptions
      );
      action(getLanguageDetails());
    }
  }, [tokenDetails]);
  useEffect(() => {
    if (languageDetails?.length) {
      const preferredLanguage = languageDetails.find(
        (lang: any) => lang.isPreferredLanguage === true
      );
  
      if (preferredLanguage) {
        setFavoriteLanguage(preferredLanguage.code);
        setSelectedLanguage(preferredLanguage);
  
        action(setLanguage(preferredLanguage.code));
      }
    }
  }, [languageDetails]);
  const loginHandler = async () => {
    console.log(
      "loginHandler called",
      params.get("code"),
      cookies.codeVerifier
    );
    action(
      getTokenDetails({
        code: params.get("code"),
        codeVerifier: cookies.codeVerifier,
      })
    );
  };

  // const changeHandler = (val: string, name: string) => {
  //   sessionStorage.setItem("languageCode", val);
  //   action(setLanguage(val));
  //   window.location.href = "/";
  // };
  const changeHandler = (language: any) => {
    setSelectedLanguage(language);
    action(setLanguage(language.code));
  };

  // const handleFavoriteLanguage = async (languageCode: string) => {
  //   setFavoriteLanguage(languageCode);
  
  //   try {
  //     await LoginService.savePreferredLanguage({
  //       languageCode,
  //     });
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };
  // const handleFavoriteLanguage = async (languageCode: string) => {
  //   setFavoriteLanguage(languageCode);
  
  //   try {
  //     await LoginService.savePreferredLanguage({
  //       userId: Number(cookies.userId),
  //       languageCode,
  //     });
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };
  
  const handleFavoriteLanguage = async (languageCode: string) => {
    const newLanguage =
      favoriteLanguage === languageCode ? "" : languageCode;
 
    setFavoriteLanguage(newLanguage);
 
    try {
      await LoginService.savePreferredLanguage({
        userId: Number(cookies.userId),
        languageCode: newLanguage,
      });
    } catch (error) {
      console.error(error);
    }
  };

  const DropDownIcon = (options: any) => (
    <img
      alt="dropdown icon"
      style={{
        transform:
          options.iconProps["data-pr-overlay-visible"] && "rotate(180deg)",
      }}
      src={dropdownIcon}
      {...options.iconProps}
    />
  );
  
  // const languageTemplate = (option: any) => {
  //   return (
  //     <div
  //       style={{
  //         display: "flex",
  //         justifyContent: "space-between",
  //         width: "100%",
  //         alignItems: "center",
  //       }}
  //     >
  //       <span>{option.languageName}</span>
  
  //       <span
  //         onClick={(e) => {
  //           e.stopPropagation();
  //           handleFavoriteLanguage(option.code);
  //         }}
  //       >
  //         {favoriteLanguage === option.code ? (
  //           <i
  //             className="pi pi-star-fill"
  //             style={{ color: "#FFD700" }}
  //           />
  //         ) : (
  //           <i
  //             className="pi pi-star"
  //             style={{ color: "#C0C0C0" }}
  //           />
  //         )}
  //       </span>
  //     </div>
  //   );
  // };
  const languageTemplate = (option: any) => {
    const isSelected =
      selectedLanguage?.code === option.code;
  
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100%",
          alignItems: "center",
          border: isSelected
            ? "1px solid #40BBBD"
            : "1px solid transparent",
          borderRadius: "4px",
          padding: "6px",
        }}
      >
        <span>{option.languageName}</span>

        <i
          className={
            favoriteLanguage === option.code
              ? "pi pi-star-fill"
              : "pi pi-star"
          }
          style={{
            color:
              favoriteLanguage === option.code
                ? "#40BBBD"
                : "#C0C0C0",
            cursor: "pointer",
          }}
          onClick={(e) => {
            e.stopPropagation();
            handleFavoriteLanguage(option.code);
          }}
        />
        
      </div>
    );
  };
  return (
    <ErrorBoundary>
      <BlockUI
        blocked={isApiLoading}
        fullScreen
        template={<ThreeDots height="80" width="80" color="#40BBBD" />}
      >
        <div
          className="container-fluid login-container"
          style={{
            width: `${windowDimensions.width}px`,
            height: `${windowDimensions.height}px`,
          }}
        >
          <Header />
          <h1 className="fw-normal">Welcome to Food for the Hungry&apos;s</h1>
          <div style={{ display: "flex", alignItems: "baseline" }}>
            <h1 className="mr-2 fw-normal">new</h1>
            <h1 className="fw-bold">Ecosystem Platform</h1>
          </div>

          <div className="mt-5">

            <fieldset
              className="dropdwon-fildset"
            >
              {/* <Dropdown
                onChange={(e) => {
                  changeHandler(e.target.value?.code, "language");
                }}
                options={languageDetails}
                optionLabel="languageName"
                placeholder={t("Select your Language")}
                className="dropdown-custom w-full"
                dropdownIcon={(options) => DropDownIcon(options)}
                filter
                resetFilterOnHide
              /> */}

              <Dropdown
                value={selectedLanguage}
                onChange={(e) => changeHandler(e.value)}
                options={languageDetails}
                optionLabel="languageName"
                placeholder={t("Select your Language")}
                className="dropdown-custom w-full"
                dropdownIcon={(options) => DropDownIcon(options)}
                itemTemplate={languageTemplate}
                filter
                resetFilterOnHide
              />

            </fieldset>
            <div className="mt-3">
              <button
                className="login-btn"
                disabled={!selectedLanguage}
                onClick={() => {
                  console.log("Language:", selectedLanguage);
                  sessionStorage.setItem(
                    "languageCode",
                    selectedLanguage.code
                  );

                  //navigate("/");
                  window.location.href = "/";
                }}
              >
                Login
              </button>
            </div>
            {/* 
            <TextField
              id="select"
              label="Select your Language"
              sx={{ width: 300 }}
              value={Object.keys(languageDetails).length !== 0 ? language : ""}
              className="login-language"
              onChange={(e) => {
                changeHandler(e.target.value, "language");
              }}
              select
            >
              {languageDetails.map((ele: any) => {
                return (
                  <MenuItem value={ele.code} key={ele.code}>
                    {ele.languageName}
                  </MenuItem>
                );
              })}
            </TextField> */}
          </div>
        </div>

      </BlockUI>
    </ErrorBoundary>
  );
};

export default Login;
